import Vue from "vue";
import VueRouter from "vue-router";
import ChildSeat from "../ChildSeat.vue"; // 引入儿童座椅的组件
import ChildSeatC from "@/ChildSeatC.vue";
import AdultSeat from "../AdultSeat.vue"; // 引入成人座椅的绑定组件

// 引入成人座椅相关的h5页面
import wxcode from "../wxcode.vue"; // 引入微信扫码组件
import btnList from "@/btnList.vue"; // 选择充电、 功能套餐首页
import charge from "@/AdultSeat/charge.vue"; // 充电页面
import orderpay from "../orderpay.vue"; // 套餐价格
import my from "@/AdultSeat/my.vue"; // 我的页面

import orderList from "@/AdultSeat/orderList.vue"; // 全部订单、运行中订单、退款订单
import orderDetail from "@/AdultSeat/orderDetail.vue"; //订单详情
Vue.use(VueRouter);

const routes = [
  {
    path: "/ChildSeat",
    name: "ChildSeat",
    component: ChildSeat, // 儿童座椅的组件
  },
  {
    path: "/ChildSeatC",
    name: "ChildSeatC",
    component: ChildSeatC, // 私域
  },
  {
    path: "/AdultSeat",
    name: "AdultSeat",
    component: AdultSeat, // 成人座椅的绑定组件
  },
  {
    path: "/",
    redirect: "/orderpay", // 默认过渡页面
  },
  {
    path: "/orderpay",
    name: "wxcode",
    component: wxcode, // 过渡页面
  },
  {
    path: "/wxcode",
    name: "orderpay",
    component: orderpay, // 套餐价格
  },
  {
    path: "/btnList",
    name: "btnList",
    component: btnList, // 选择充电、 功能套餐
  },
  {
    path: "/charge",
    name: "charge",
    component: charge, // 充电页面
  },
  {
    path: "/my",
    name: "my",
    component: my, // 我的
  },

  {
    path: "/orderList",
    name: "orderList",
    component: orderList, // 订单列表
  },
  {
    path: "/orderDetail",
    name: "orderDetail",
    component: orderDetail, // 订单详情
  },
];

const router = new VueRouter({
  mode: "history", // 可选：history模式（需服务器支持）
  base: process.env.BASE_URL,
  routes,
});

export default router;
